import React, { useState } from "react";
import "../components/form.css";
import "../components/prompt.css";
import { db } from "../firebase.js";
import { getDocs, collection, query, where, setDoc } from "firebase/firestore";
import {getRef, ref, uploadBytes, getDownloadURL, getStorage} from "firebase/storage";
import { useAuth } from "../utilities/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// const BASE_URL = "https://poster-gen-backend-v1.onrender.com";
// const BASE_URL = "http://localhost:5000";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

const toastOptions = {
  position: "bottom-right",
  autoClose: 8000,
  pauseOnHover: true,
  draggable: true,
  theme: "dark",
};

async function share(e) {
  e.preventDefault();
  let img_url = document.getElementById("preview-img").src;
  let img_blob = await (await fetch(img_url)).blob();
  let share_data = {
    files: [
      new File([img_blob], `Poster-${new Date().getTime()}.jpg`, {
        type: img_blob.type,
      }),
    ],
    text: "Some title text",
  };
  if (navigator.share && navigator.canShare(share_data)) {
    await navigator.share(share_data);
  } else {
    alert(
      "Sharing not available for this device. Please download the poster and share it manually."
    );
  }
}

async function getPoster(e, currentUser, updateBalance, balanceCheck,store) {
  e.preventDefault();
  if (!currentUser) {
    return toast.error("You need to be logged in to do this.", toastOptions);
  }
  document.getElementById("generate").style.display = "none";
  document.getElementById("preview").style.display = "none";
  document.getElementById("loader").style.display = "flex";
  let image = await generatePoster(updateBalance, balanceCheck,store);
  if (image) {
    document.getElementById("loader").style.display = "none";
    
    document.getElementById("preview").style.display = "flex";
    document.getElementById("preview").className = "form-nested m-1 flex-1";
    document.getElementById("preview-img").src = image;
    document.getElementById("section_id").textContent = "Customize";
    let extra_options = document.getElementsByClassName("custom-toggle-field");
    for(let i=0; i<extra_options.length; i++){
      extra_options.item(i).classList.remove("custom-toggle-field-hidden");
    }
  } else {
    document.getElementById("loader").style.display = "none";
    document.getElementById("generate").style.display = "inline-block";
  }
}

async function generatePoster(updateBalance, balanceCheck,store) {
  const form = document.getElementById("prompt-form");
  const formElements = form.elements;
  const formData = new FormData(form);

  // Check required fields
  for (let i = 0; i < formElements.length; i++) {
    const element = formElements[i];
    if (element.required && !element.value) {
      toast.error(`"${String(element.placeholder).substring(0, String(element.placeholder).length-1)}" field is required!`, toastOptions);
      return;
    }
  }
  
  const use_image = document.getElementById("use_image");
  formData.append("use_image", use_image.checked);

  const use_ai_image = document.getElementById("use_ai_image");
  if(use_ai_image == undefined) {
    formData.append("use_ai_image", false);
  } else {
    formData.append("use_ai_image", use_ai_image.checked);

    const customImageInput = document.querySelector('input[name="custom_image"]');
    if(customImageInput == undefined) {
      formData.append("custom_image", null);
    } else {
      if (!use_ai_image.checked && customImageInput.files.length == 0) {
        toast.error(`Please upload a custom image!`, toastOptions);
        return;
      } else{
        formData.append("custom_image", customImageInput.files[0]);
      }
    }
  }

  // console.log(formData);

  let formDataObject = {};
  formData.forEach((value, key) => {
      formDataObject[key] = value;
  });
  // console.log(formDataObject);
  // console.log(balanceCheck());
  // console.log("here");
  let balance = await balanceCheck();
  // console.log(balance);
  
  if(!balance){
    return;
  }
  try {
    let image = await fetch(`${BASE_URL}/generate-image`, {
      method: "POST",
      body: formData,
    });

    let imageBlob = await image.blob();

    // for (let i = 0; i < formElements.length; i++) {
    //   if ((i === 0) || (i === 7)) {
    //     const element = formElements[i];
    //     if (element.type !== "submit") {
    //       element.disabled = true;
    //     }
    //   }
    // }
    // We are now allowing the user to regenerate the image.
    updateBalance();
    store(imageBlob);
    return URL.createObjectURL(imageBlob);
  } catch (error) {
    console.error("Error fetching image:", error);
    // Handle the error, show a message, or take appropriate action
  }
}


async function download(e) {
  e.preventDefault();

  let img_url = document.getElementById("preview-img").src;
  const link = document.createElement("a");
  link.href = img_url;
  link.download = `Poster-${new Date().getTime()}.jpg`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function Prompt() {
  let { currentUser } = useAuth();
  let [useImage, setUseImage] = useState(true);
  let [useAIImage, setUseAIImage] = useState(true);
  let [template, setTemplate] = useState(null);
  let [showSelectTemplate, setShowSelectTemplate] = useState(false);
  let [maxTemplateCount, setMaxTemplateCount] = useState(0);
  let [templateType, setTemplateType] = useState("dual"); // ["single", "dual"]
  const updateBalance = async () => {
    const q = query(
      collection(db, "Users"),
      where("uid", "==", currentUser.uid)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      setDoc(doc.ref, {balance: doc.data().balance - 5}, {merge: true});
    });
  };
  const balanceCheck = async () => {
    let check = false;
    const q = query(
      collection(db, "Users"),
      where("uid", "==", currentUser.uid)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const currentBalance = doc.data().balance;
      // console.log(currentBalance);
      if(currentBalance < 5) {
        toast.error("Insufficient Credits",toastOptions);
      }else{
        // console.log("here");
        check = true;
      }

    });
    return check;
  };
  function toggleUseImage(e){
    setUseImage(!useImage);
    setTemplate(null);
    setTemplateType(!useImage ? "dual" : "single");
    setMaxTemplateCount(0);
  }

  const store=(img)=>{
    try{
      const storage = getStorage();
      const storageRef = ref(storage, 'history');
      const imageRef = ref(storageRef, `${new Date().getTime()}.jpg`);
      // console.log('here', typeof img);
      uploadBytes(imageRef, img).then((snapshot) => {
        getDownloadURL(snapshot.ref).then((url) => {
          // console.log(url);
          const q = query(
            collection(db, "Users"),
            where("uid", "==", currentUser.uid)
          );
          getDocs(q).then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              setDoc(doc.ref, {
                history: [...doc.data().history, url],
              }, {merge: true});
            });
          })
        });
        // console.log('Uploaded a blob or file!', snapshot);
      })
    .catch((error) => {console.log(error);});
    }
    catch(e){
      console.log(e);
    }
  }
  async function selectTemplate(e){
    e.preventDefault();
    setShowSelectTemplate(true);
    // get max template count from api
    if(useImage){
      setMaxTemplateCount((await (await fetch(`${BASE_URL}/get_dual_templates`)).json()).number_of_items);
      setTemplateType("dual");
    } else {
      setMaxTemplateCount((await (await fetch(`${BASE_URL}/get_single_templates`)).json()).number_of_items);
      setTemplateType("single");
    }
  }

  return (
    <div className="form-parent wide-form-parent">
      <form id="prompt-form" action="#">
        <div className="form prompt-form">
          <h1 className="text-4xl font-bold mb-4">Generate a Poster</h1>
          <h2 className="mb-4 md:mb-2">
            Get an AI generated poster for your event in 3 simple steps
          </h2>
          <div className="steps">
            <div className="step">
              <span>1</span>
              Enter basic details about the event like Title and Date
            </div>
            <div className="step">
              <span>2</span>
              Customize the poster with your own Text and Images
            </div>
            <div className="step">
              <span>3</span>
              Download and Share the poster!
            </div>
          </div>
          <h2 className="text-2xl font-bold mb-4" id="section_id">Enter the details</h2>
          <div className="flex flex-row flex-wrap items-center">
            <div className="flex m-1 flex-1">
              <input
                type="text"
                name="event"
                placeholder="Event Description*"
                required
              />
              <input type="text" name="title" placeholder="Title of the event" />
              <input
                type="text"
                name="subtitle"
                placeholder="Organization Name*"
                required
              />
              <input type="text" name="venue" placeholder="Venue*" required />
              <input type="text" name="time" placeholder="Time*" required />
              <input type="text" name="date" placeholder="Date*" required />
              <input type="text" name="custom_text" placeholder="Custom text" />
              
              <div className="custom-toggle-field">
                <div>
                  <input type="checkbox" id="use_image" defaultChecked={useImage} onChange={toggleUseImage} />
                  <label for="use_image">Toggle</label>
                  <span>Use Image</span>
                </div>
              </div>
              {
                useImage && (
                  <>
                  <div className="custom-toggle-field" id="ai_image_toggle">
                    <div>
                      <input type="checkbox" id="use_ai_image" defaultChecked={useAIImage} onChange={()=>{setUseAIImage(!useAIImage)}} />
                      <label for="use_ai_image">Toggle</label>
                      <span>Use Generative AI Images</span>
                    </div>
                  </div>
                  {
                    useAIImage ? <></> : (
                      <input type="file" name="custom_image" id="custom_image" placeholder="Custom image" />
                    )
                  }
                  </>
                )
              }
              <button
                className="filled mt-2"
                onClick={selectTemplate}
                id="template_select"
              >
                Select Template
              </button>
              <input type="hidden" name="template" placeholder="Template*" required/>
              {template && <img src={template} className="mx-auto rounded-lg" style={{maxWidth:'min(500px, 100%)'}} alt="" />}
              
              <button
                className="filled mt-2"
                onClick={(e) => getPoster(e, currentUser, updateBalance, balanceCheck,store)}
                id="generate"
              >
                Generate
              </button>
              
              {/* <div className="custom-toggle-field custom-toggle-field-hidden">
                <div>
                  <input type="checkbox" id="template" />
                  <label for="template">Toggle</label>
                  <span>Regenerate template</span>
                </div>
              </div>
              <div className="custom-toggle-field custom-toggle-field-hidden">
                <div>
                  <input type="checkbox" id="ai_image" name="ai_image"/>
                  <label for="ai_image">Toggle</label>
                  <span>Regenerate AI Image</span>
                </div>
              </div>
              <div className="custom-toggle-field custom-toggle-field-hidden">
                <div>
                  <input type="checkbox" id="template" />
                  <label for="ai_text">Toggle</label>
                  <span>Regenerate AI Caption</span>
                </div>
              </div>  */}
            </div>
            <div className="loader flex-1" id="loader">
              <img src="/images/loading.svg" alt="Loading..." />
              It might take a few minutes. Please hold on tight...
            </div>
            <div className="form-hidden m-1 flex-1" id="preview">
              <div className="preview-img">
                <img src="" alt="AI Generated Poster" id="preview-img" />
                <div></div>
              </div>
              <button
                className="filled"
                onClick={(e) => getPoster(e, currentUser, updateBalance, balanceCheck,store)}
                id="regenerate"
              >
                Regenerate
              </button>
              <div className="share-options">
                <button className="filled" onClick={share} id="share">
                  Share
                </button>
                <button className="filled" onClick={download} id="download">
                  Download
                </button>
              </div>
              <button
                className="filled"
                onClick={()=>(window.location.href = "/prompt")}
                id="restart"
              >
                Start Again
              </button>
            </div>
          </div>
        </div>
      </form>
      <ToastContainer />
      {showSelectTemplate && 
        <div className="fixed z-50 w-full h-full top-0 left-0 grid place-items-center bg-white">
          <div className="bg-white shadow-lg rounded-lg select_template_menu overflow-hidden">
            {maxTemplateCount < 0 ? <img src="/images/loading.svg" alt="Loading..." className="mx-auto"/> : (
              <>
              <div className="flex flex-row justify-between items-center p-2">
                <h1 className="text-2xl font-bold">Select Template</h1>
                <button onClick={()=>{setShowSelectTemplate(false)}} className="text-2xl font-bold">X</button>
              </div>
              <div className="flex flex-row flex-wrap justify-center items-center overflow-y-scroll h-full">
                {
                  [...Array(maxTemplateCount).keys()].map((i) => (
                    <img src={`${BASE_URL}/get_template/${templateType}/${i+1}`} className="w-48 m-2 rounded-lg cursor-pointer" alt="" onClick={()=>{setTemplate(`${BASE_URL}/get_template/${templateType}/${i+1}`); document.querySelector('input[name="template"]').value = i+1; setShowSelectTemplate(false)}}/>
                  ))
                }
              </div>
              </>
            )}
          </div>
        </div>
      }
    </div>
  );
}

export default Prompt;
